import { defineComponent as _defineComponent } from 'vue'
import { TtPage, User } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { startCase, sumBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";
import { formatCount } from "@/helpers/formatCount";
import TTPageDetailsModal from "@/components/modules/bet-details/TTPageDetailsModal.vue";
import { useQuery } from "@vue/apollo-composable";
import { computed, ref } from "vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TtTicketsModal',
  props: {
    value: { type: Boolean },
    startReleaseDate: null,
    endReleaseDate: null,
    userId: null,
    includeDownlines: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, startReleaseDate: string, endReleaseDate: string, userId: User["userId"], includeDownlines: boolean };



const { result: userResult, loading } = useQuery<{ user: User }>(
  queries.userTtReportPages,
  {
    releaseDateStart: props.startReleaseDate,
    releaseDateEnd: props.endReleaseDate,
    behalfOf: props.userId,
    includeDownlines: props.includeDownlines,
  }
);

const { $t } = useTranslation();

const user = computed(() => {
  return userResult.value?.user;
});

const showPageDetailModal = ref<boolean>(false);
const selectedPageId = ref(null as null | TtPage["id"]);
const selectedPageReleaseDate = ref(null as null | TtPage["releaseDate"]);



const allPages = computed(() => {
  if (!userResult.value) return [];

  return [...(userResult.value?.user.ttPages ?? [])].sort((a, b) => {
    // first sort by releaseDate
    const timeDiff = customMoment(a.releaseDate).diff(
      customMoment(b.releaseDate)
    );
    if (timeDiff !== 0) {
      return timeDiff;
    }

    const createdDiff = customMoment(a.createdAt).diff(
      customMoment(b.createdAt)
    );
    return createdDiff;
  });
});

const summary = computed(() => {
  if (!allPages.value) {
    return null;
  }
  return {
    unit: sumBy(allPages.value, (p) => p.calculation.unit),
  };
});

function selectPage(page: TtPage) {
  selectedPageId.value = page.id;
  selectedPageReleaseDate.value = page.releaseDate;
  showPageDetailModal.value = true;
}

function formatDate(date: string | Date) {
  return customMoment(date).format("DD MMM YYYY");
}
function formatReleaseDate(date: string | Date) {
  return customMoment(date).format("ddd, DD MMM");
}
function formatDatetime(date: string) {
  return customMoment(date).format("DD/MM HH:mm:ss");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, userResult, loading, $t, user, showPageDetailModal, selectedPageId, selectedPageReleaseDate, emit, allPages, summary, selectPage, formatDate, formatReleaseDate, formatDatetime, toggleModal, formatDollar, startCase, formatCount, TTPageDetailsModal }
}

})